module.exports = __webpack_public_path__ + "img/king-capture-single.18b59c8c.gif";